export default __webpack_public_path__ + "static/media/yellowPlus.01d8c821.svg";